import React from "react";
import Select from "react-select";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { truncate } from "lodash";

const JobPOPicker = ({
  jobNumber,
  value,
  onChange,
  placeholder = "Select Job PO...",
  ...props
}) => {
  const { backendUrl } = useAuth();

  const { data: jobPOs, isLoading, error } = useQuery(
    ["jobPOs", jobNumber],
    async () => {
      if (!jobNumber) return [];
      const response = await fetch(`${backendUrl}/api/job/pos/${jobNumber}`);
      if (!response.ok) {
        throw new Error("Failed to fetch job POs");
      }
      const { data } = await response.json();
      return data;
    },
    {
      enabled: !!jobNumber,
      staleTime: 0,
    }
  );

  try {
    const options =
      (Array.isArray(jobPOs) &&
        jobPOs?.map(po => ({
          value: po.poNumber,
          label: `${po.poNumber} - ${truncate(po.poTitle, { length: 50 })}`,
        }))) ||
      [];

    // Find the selected option to get the proper label
    const selectedOption =
      options.find(option => option.value === value) || null;

    return (
      <Select
        value={selectedOption}
        onChange={onChange}
        options={options}
        isLoading={isLoading}
        isDisabled={!jobNumber || isLoading}
        placeholder={placeholder}
        isClearable
        isSearchable
        loadingMessage={() => "Loading job POs..."}
        noOptionsMessage={() => (error ? "Error loading POs" : "No POs found")}
        classNamePrefix="form-select"
        {...props}
      />
    );
  } catch (error) {
    console.error("Error in JobPOPicker:", error);
    return <p>Error loading job POs</p>;
  }
};

export default JobPOPicker;
